import React from 'react';
import { isDM510 } from '../utils/modelLabel';

// The control panel in the same outline style as the heroicons used everywhere
// else. Pass the device's model to get the right panel: the DM510 is a keypad
// panel, a wide display above a row of keys; the DM2500i (and anything unknown)
// is the wall-mount box with its screen window, mounting tabs on top and feet
// below. Stroke follows currentColor and size comes from className, so it
// drops in wherever a heroicon sat.
const PANEL_2500I =
  'M7.3 5.25V3.9h2.2v1.35M14.5 5.25V3.9h2.2v1.35M4.5 5.25h15v13.5h-15zM7.25 7.5h9.5v5.25h-9.5zM7.3 18.75v1.35h2.2v-1.35M14.5 18.75v1.35h2.2v-1.35';

const PANEL_510 =
  'M3.75 4.5h16.5v15h-16.5zM6 6.75h12v6H6zM6 15.5h2v2H6zM9.35 15.5h2v2h-2zM12.65 15.5h2v2h-2zM16 15.5h2v2h-2z';

const DeviceIcon = ({ model, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d={isDM510(model) ? PANEL_510 : PANEL_2500I}
    />
  </svg>
);

export default DeviceIcon;
